import { declareParams, JsonApiRequestError } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createStore, Store } from 'effector';
import { RegistryParams, RegistryQuery } from 'shared/lib';
import { createAuthQuery } from '../auth-http-client';
import { createPaginatedSchema, User, UserRole, userSchema } from '../types';

export type OriginalUserRegistryParams = {
	sortField?: string | null;
	sortDirection?: string;
	page?: number;
	limit?: number;
	name?: string;
	accountIds?: string[];
	roles?: string[];
};

export type UserRegistryFilters = {
	name: string;
	accountIds: number[];
	roles: UserRole[];
};

export type UserRegistryParams = RegistryParams<UserRegistryFilters>;

export type UserRegistryQuery = RegistryQuery<User, UserRegistryFilters, JsonApiRequestError>;

export const createUserRegistryQuery = ($accountId?: Store<number | null>): UserRegistryQuery =>
	createAuthQuery({
		params: declareParams<UserRegistryParams>(),
		request: {
			method: 'GET',
			url: '/user/list',
			query: {
				source: $accountId ?? createStore<number | null>(null),
				fn: (params, accountId) => ({
					page: params.page,
					limit: params.limit,
					sortField: params.sortField ?? undefined,
					sortDirection: params.sortDirection,
					name: params.filters.name ?? undefined,
					roles: params.filters.roles?.map((role) => role.toString()) ?? undefined,
					accountIds: [
						...(accountId ? [String(accountId)] : []),
						...params.filters.accountIds.map(String),
					],
				}),
			},
		},
		response: {
			contract: zodContract(createPaginatedSchema(userSchema)),
		},
	});
